import Overview from "../Pages/aboutUs/Overview";
import Careers from "../Pages/Careers";
import Contact from "../Pages/contact";
import Actsandlaws from "../Pages/Download/actsandlaws";
import Circular from "../Pages/Download/circular";
import Citizencharter from "../Pages/Download/citizencharter";
import Resoultions from "../Pages/Download/resolutions";
import EventPermission from "../Pages/permissionAndLicence/EventPermission";
import FilmShooting from "../Pages/permissionAndLicence/FilmShooting";
import Rti from "../Pages/Rti";
import Tenders from "../Pages/tenders";
import Home from "../Pages/Home/home";
import Leadership from "../Pages/aboutUs/Leadership";
import Publication from "../Pages/Resource/publication";
import Gallery from "../Pages/Resource/Gallery";
import Awards from "../Pages/aboutUs/Awards";
import Scheme from "../Pages/aboutUs/Scheme";
import Conversation from "../Pages/Research/conservation";
import Adminstructure from "../Pages/aboutUs/Adminstructure";
import Monuments from "../Pages/Attraction/monument/Monuments";
import Museums from "../Pages/Attraction/Museum/museums";
import Excavations from "../Pages/Research/excavations";
import RatnagiriPage from "../Pages/Research/Ratnagiri";
import Searchpage from "../components/Searchpage";
import ScreenReader from "../components/screenReader";
import Events from "../Pages/Events";
import SenitoryPage from "../Pages/Download/senioritylist";
import MuseumDetails from "../Pages/Attraction/Museum/MuseumDetails";
import DivisionMonument from "../Pages/Attraction/monument/ratnagiriMonument";
import DistrictMonuments from "../Pages/Attraction/monument/palghar";
import SingleMonumentPage from "../Pages/Attraction/monument/shirgaon";
import Dashboardpage from "../Pages/Dashboard/dashboardpage";
import NOCDevelopement from "../Pages/permissionAndLicence/NOCDevelopement";
import MonumenteventPermission from "../Pages/permissionAndLicence/MonumenteventPermission";
import ResearchPermission from "../Pages/permissionAndLicence/ResearchPermission";
import Courtorder from "../Pages/Resource/Courtorder";
import Shop from "../Pages/Shop";
import Login from "../Pages/login";
import Worldheritagefort from "../Pages/Worldheritage/worldheritagefort";
import Worldheritage from "../Pages/Worldheritage/worldheritage";
import Worldheritagefortdetails from "../Pages/Worldheritage/worldheritagefortdetails";
import Reportantiquities from "../Pages/Attraction/ReportAntiquities/reportantiquities";
import Sitemap from "../components/Sitemap";
import Advertisement from "../Pages/Home/Advertisement";
import Recruitment from "../Pages/aboutUs/Recruitment";

export const publicRoute = [
  { id: 1, path: "", element: <Home /> },
  { id: 2, path: "museums", element: <Museums /> },
  { id: 3, path: "contact", element: <Contact /> },
  { id: 4, path: "film-shooting", element: <FilmShooting /> },
  { id: 5, path: "event-permission", element: <EventPermission /> },
  { id: 6, path: "legislations", element: <Actsandlaws /> },
  { id: 7, path: "gov-resolutions", element: <Resoultions /> },
  { id: 8, path: "citizen-charter", element: <Citizencharter /> },
  { id: 9, path: "circulars", element: <Circular /> },
  { id: 10, path: "tenders", element: <Tenders /> },
  { id: 11, path: "overview", element: <Overview /> },
  { id: 12, path: "rti", element: <Rti /> },
  { id: 13, path: "careers", element: <Careers /> },
  { id: 14, path: "publication", element: <Publication /> },
  { id: 15, path: "leadership", element: <Leadership /> },
  // { id: 16, path: "library", element: <Library /> },
  { id: 17, path: "gallery", element: <Gallery /> },
  { id: 18, path: "awards", element: <Awards /> },
  { id: 19, path: "scheme", element: <Scheme /> },
  { id: 20, path: "conversation", element: <Conversation /> },
  { id: 21, path: "adminstructure", element: <Adminstructure /> },
  { id: 22, path: "monuments", element: <Monuments /> },
  { id: 23, path: "museums/:museumId", element: <MuseumDetails /> },
  { id: 24, path: "excavations", element: <Excavations /> },
  { id: 25, path: "excavations/:division", element: <RatnagiriPage /> },
  { id: 26, path: "monuments/:divisionName", element: <DivisionMonument /> },
  // <id: 26, path: "/monuments/division/:divisionName", element: <DivisionMonument /> />,
  { id: 27, path: "monuments/:divisionName/:districtName", element: <DistrictMonuments /> },
  { id: 28, path: "monuments/:divisionName/:districtName/:fortId", element: <SingleMonumentPage /> },
  { id: 29, path: "search", element: <Searchpage /> },
  { id: 30, path: "screenreader", element: <ScreenReader /> },
  { id: 31, path: "events", element: <Events /> },
  { id: 32, path: "senioritylist", element: <SenitoryPage /> },
  { id: 33, path: "dashboard", element: <Dashboardpage /> },
  { id: 34, path: "reportantiquities", element: <Reportantiquities /> },
  { id: 35, path: "NOCDevelopement", element: <NOCDevelopement /> },
  { id: 36, path: "monumenteventpermission", element: <MonumenteventPermission /> },
  { id: 37, path: "researchpermission", element: <ResearchPermission /> },
  { id: 38, path: "courtorder", element: <Courtorder /> },
  { id: 39, path: "worldheritage", element: <Worldheritage /> },
  { id: 40, path: "shop", element: <Shop /> },
  { id: 41, path: "login", element: <Login /> },
  { id: 42, path: "/fort/:id", element: <Worldheritagefort/>},
  { id: 43, path: "worldheritagefortdetails", element: <Worldheritagefortdetails /> },
  { id: 44, path: "sitemap", element: <Sitemap /> },
  { id: 45, path: "advertisement", element: <Advertisement /> },
  { id: 46, path: "recruitment", element: <Recruitment /> },


];
